module.exports = __webpack_public_path__ + "img/state2.83819cbe.png";